import { useState } from "react";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";

export default function QRDownload({ previewRef }) {
  const [loading, setLoading] = useState(null);

  const downloadPNG = async () => {
    if (!previewRef.current) return;

    try {
      setLoading("png");

      const dataUrl = await toPng(previewRef.current, {
        cacheBust: true,
        backgroundColor: "#ffffff",
        pixelRatio: 3,
      });

      const link = document.createElement("a");
      link.download = "zafflo-qr.png";
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error("PNG download failed:", error);
    } finally {
      setLoading(null);
    }
  };

  const downloadPDF = async () => {
    if (!previewRef.current) return;

    try {
      setLoading("pdf");

      const dataUrl = await toPng(previewRef.current, {
        cacheBust: true,
        backgroundColor: "#ffffff",
        pixelRatio: 3,
      });

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [101.6, 152.4],
      });

      const imgProps = pdf.getImageProperties(dataUrl);
      const pdfWidth = 101.6;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      const yPosition = (152.4 - pdfHeight) / 2;

      pdf.addImage(dataUrl, "PNG", 0, yPosition, pdfWidth, pdfHeight);
      pdf.save("zafflo-qr-4x6.pdf");

    } catch (error) {
      console.error("PDF download failed:", error);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="mt-6">

      {/* 🎴 DARK ACTION CARD */}
      <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 space-y-5 backdrop-blur-sm">

        {/* 🧠 HEADER */}
        <div className="text-center">
          <p className="text-sm text-white/80 font-medium">
            Your QR is ready
          </p>
          <p className="text-xs text-white/40 mt-1">
            Download and start using it instantly
          </p>
        </div>

        {/* 📄 PRIMARY BUTTON */}
        <button
          onClick={downloadPDF}
          disabled={loading}
          className="w-full bg-white text-black py-3 rounded-xl font-medium text-sm 
          hover:bg-white/90 transition-all duration-200 
          hover:scale-[1.01] active:scale-[0.98] 
          disabled:opacity-60 flex items-center justify-center"
        >
          {loading === "pdf" ? "Preparing PDF..." : "Download 4×6 Print PDF"}
        </button>

        {/* 🖼 SECONDARY BUTTON */}
        <button
          onClick={downloadPNG}
          disabled={loading}
          className="w-full border border-white/[0.15] text-white/70 py-3 rounded-xl text-sm 
          hover:border-white/30 hover:text-white 
          transition-all duration-200 
          hover:scale-[1.01] active:scale-[0.98] 
          disabled:opacity-60"
        >
          {loading === "png" ? "Preparing Image..." : "Download PNG"}
        </button>

        {/* 💡 HELPER TEXT */}
        <p className="text-[10px] text-white/30 text-center">
          Print-ready PDF • High-resolution PNG
        </p>

      </div>
    </div>
  );
}